export default "__VITE_ASSET__BzTnlhPl__"